var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("keep-alive", [
    _c("div", { staticClass: "modal-mask type2" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal_size sm3_size" }, [
          _c(
            "a",
            {
              staticClass: "ui_close_type2",
              attrs: { href: "javascript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" })]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content" }, [
            _c("dt", { staticClass: "ellipsis desc" }, [
              _c("i", [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIRM")))]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("MESSAGE.EUR.BP.SAVED")) +
                    "\n                        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("dd", [
              _c("table", { staticClass: "view_table noLine" }, [
                _c("colgroup", [
                  _c("col", { attrs: { width: "270px" } }),
                  _vm._v(" "),
                  _c("col", { staticClass: "*" })
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                          "(" +
                          _vm._s(_vm.$t("FIELD.GLOBAL.EMAIL")) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.userEmail))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.companyNm))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.companyNo))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.address))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.zipCd))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.homeUrl))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.contactFrstNm))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.contactLastNm))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.contactPhoneNo))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.APE.CODES")))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.pParams.apeCodes))])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "scroll_btm" }, [
              _c(
                "div",
                { staticClass: "btn_modal_wrap topLine mt-0 text-center" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "bt-type-m black",
                      on: { click: _vm.closeAndGoStep3 }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5125456a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5125456a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/JoinedConfirmPopup.vue
// module id = pizi
// module chunks = 0